var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.form && _vm.getErrors().length)?_c('span',{staticClass:"form-error"},[_vm._l((_vm.getErrors()),function(error,index){return [(index !== 0)?_c('br'):_vm._e(),_vm._v(_vm._s(error)+" ")]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }